import script from "./SolutionDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./SolutionDetailPage.vue?vue&type=style&index=0&id=2afd61d9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2afd61d9"]])

export default __exports__